import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter = ({ className = '' }) => (
  <footer
    className={`text-center text-xs text-gray-500 pt-4 pb-2 border-t border-gray-100/80 ${className}`}
  >
    <Link
      to="/terms"
      className="text-gray-600 hover:text-green-700 underline-offset-2 hover:underline transition-colors"
    >
      Terms & Conditions
    </Link>
  </footer>
);

export default AppFooter;
